module.exports = __webpack_public_path__ + "static/media/YB5M18_3.9b12a537.jpg";